import { render } from "./NavbarComp.vue?vue&type=template&id=46e1ba01"
import script from "./NavbarComp.vue?vue&type=script&lang=js"
export * from "./NavbarComp.vue?vue&type=script&lang=js"

import "./NavbarComp.vue?vue&type=style&index=0&id=46e1ba01&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__